import { useEffect, useState } from "react";
import { MapPin, Search } from "react-feather";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import GetApiCall from "../Api/GetApi";

const SearchJob = () => {
  const [jobQuery, setJobQuery] = useState("");
  const [location, setLocation] = useState("");
  const history = useNavigate()
  const handleSearch = (e) => {
    e.preventDefault();
    history(`/jobs-opening-list`, {
      state: {
        isSearch: true,
        filter: {
          fld_title: jobQuery,
          fld_type: jobQuery,
          fld_city: location,
          fld_state: location
        }
      }
    });
  };


  const [stats, setStats] = useState({
    JobPost: 0,
    JobAuditorCount: 0,
    VerifiedAuditorCount: 0,
  });


  useEffect(() => {
    GetApiCall.getRequest("JobAuditorStatistics").then((resultdes) =>
      resultdes.json().then((obj) => {
        setStats(obj?.data[0]);
      })
    );
  }, []);


  const brandColor = '#c16d18';


  console.log("SearchJob component rendered with stats:", stats);

  return (
    <div className="my-4">
      <Container>


        <div className="container-fluid px-4 pt-3 pb-5">
          {/* Hero Section */}
          <div className="text-center text-dark mb-5">
            <span className="lead text-muted mb-2 fs-5">
              Join India's fastest-growing field audit community. No experience needed!
            </span>
          </div>

          {/* Trust Indicators */}
          {/* <div className="row g-3">
            {[
              { key: 'JobPost', title: 'ACTIVE JOB POSTS', subtitle: 'Updated Daily' },
              { key: 'JobAuditorCount', title: 'TOTAL AUDITOR', subtitle: 'Avg. ₹45,000/month' },
              { key: 'VerifiedAuditorCount', title: 'VERIFIED AUDITORS', subtitle: 'Background Checked' },
            ].map(item => (
              <div className="col-lg-4 col-md-4" key={item.key}>
                <div className="card border-0 shadow-sm h-100" style={{ transition: 'transform 0.3s ease' }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05) translateY(-5px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1) translateY(0)'}>
                  <div className="card-body text-center p-4">
                    <div className="fw-bold mb-2" style={{ fontSize: '1.5rem', color: brandColor }}>
                      {stats[item.key]}          
                    </div>
                    <div className="text-dark fw-bold">{item.title}</div>
                  </div>
                </div>
              </div>
            ))}
          </div> */}


          <section
            style={{
              background: "",
              paddingTop: "",
              paddingBottom: "80px",
            }}
          >
            <Container fluid="xl">
              <div className="text-center mb-5">
                <h2
                  style={{
                    fontSize: "2.5rem",
                    fontWeight: 600,
                    color: "#2d2d2d",
                    marginBottom: "20px",
                  }}
                >
                  Why BetelJobs?
                </h2>

                <p
                  style={{
                    color: "#8a8a8a",
                    fontSize: "1.1rem",
                    maxWidth: "700px",
                    margin: "0 auto",
                  }}
                >
                  Connecting businesses with trusted auditors and creating opportunities
                  for professionals across India.
                </p>
              </div>

              <Row className="justify-content-center gx-5">

                <Col lg="3" md="6" className="text-center mb-5">
                  <h1
                    style={{
                      color: "#c16d18",
                      fontSize: "3rem",
                      fontWeight: 700,
                      marginBottom: "15px",
                    }}
                  >
                    1,000+
                  </h1>

                  <h5
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: 600,
                      color: "#444",
                      marginBottom: "15px",
                    }}
                  >
                    Auditors Onboarded
                  </h5>

                  <p
                    style={{
                      color: "#6f6f6f",
                      fontSize: "1rem",
                      lineHeight: 1.8,
                      maxWidth: "260px",
                      margin: "0 auto",
                    }}
                  >
                    Certified and experienced auditors actively registered on BetelJobs,
                    ready to support organizations across multiple industries.
                  </p>
                </Col>

                <Col lg="3" md="6" className="text-center mb-5">
                  <h1
                    style={{
                      color: "#c16d18",
                      fontSize: "3rem",
                      fontWeight: 700,
                      marginBottom: "15px",
                    }}
                  >
                    50+
                  </h1>

                  <h5
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: 600,
                      color: "#444",
                      marginBottom: "15px",
                    }}
                  >
                    Locations Covered
                  </h5>

                  <p
                    style={{
                      color: "#6f6f6f",
                      fontSize: "1rem",
                      lineHeight: 1.8,
                      maxWidth: "260px",
                      margin: "0 auto",
                    }}
                  >
                    Expanding our reach across cities and regions, connecting businesses
                    with qualified auditors wherever opportunities arise.
                  </p>
                </Col>

                <Col lg="3" md="6" className="text-center mb-5">
                  <h1
                    style={{
                      color: "#c16d18",
                      fontSize: "3rem",
                      fontWeight: 700,
                      marginBottom: "15px",
                    }}
                  >
                    200+
                  </h1>

                  <h5
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: 600,
                      color: "#444",
                      marginBottom: "15px",
                    }}
                  >
                    Jobs Published
                  </h5>

                  <p
                    style={{
                      color: "#6f6f6f",
                      fontSize: "1rem",
                      lineHeight: 1.8,
                      maxWidth: "260px",
                      margin: "0 auto",
                    }}
                  >
                    Audit projects and compliance opportunities posted by employers,
                    helping professionals discover new engagements every day.
                  </p>
                </Col>

                <Col lg="3" md="6" className="text-center mb-5">
                  <h1
                    style={{
                      color: "#c16d18",
                      fontSize: "3rem",
                      fontWeight: 700,
                      marginBottom: "15px",
                    }}
                  >
                    95%
                  </h1>

                  <h5
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: 600,
                      color: "#444",
                      marginBottom: "15px",
                    }}
                  >
                    Successful Matches
                  </h5>

                  <p
                    style={{
                      color: "#6f6f6f",
                      fontSize: "1rem",
                      lineHeight: 1.8,
                      maxWidth: "260px",
                      margin: "0 auto",
                    }}
                  >
                    Connecting the right auditors with the right opportunities through a
                    streamlined and efficient hiring process.
                  </p>
                </Col>

              </Row>
            </Container>
          </section>


        </div>


        <div className="text-center">
          <h3 className="text-center mb-2 section-title text-dark">🎯 Find Your Perfect Field Audit Job</h3>
          <p className="text-muted mb-0">Start earning today! Enter your preferences below:</p>
        </div>
        <Form onSubmit={handleSearch} className="shadow-sm rounded p-4">
          <Row className="g-3 align-items-center">
            <Col md={5}>
              <FormGroup className="mb-2 md-mb-0 position-relative">
                <div className="position-relative">
                  <Search
                    size={20}
                    className="position-absolute text-muted"
                    style={{
                      top: "50%",
                      left: "10px",
                      transform: "translateY(-50%)",
                    }}
                  />
                  <Input
                    type="text"
                    placeholder="Job type (Part/Full time, gigs)"
                    value={jobQuery}
                    onChange={(e) => setJobQuery(e.target.value)}
                    style={{ paddingLeft: "40px" }} // Adds space for the icon
                  />
                </div>
              </FormGroup>
            </Col>
            <Col md={5}>
              <FormGroup className="mb-2 md-mb-0 position-relative">
                <div className="position-relative">
                  <MapPin
                    size={20}
                    className="position-absolute text-muted"
                    style={{
                      top: "50%",
                      left: "10px",
                      transform: "translateY(-50%)",
                    }}
                  />
                  <Input
                    type="text"
                    placeholder="City, State"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    style={{ paddingLeft: "40px" }} // Adds space for the icon
                  />
                </div>
              </FormGroup>
            </Col>
            <Col md={2}>
              <Button
                className="btns mb-1"
                style={{ border: "none", textTransform: "capitalize" }}
              >
                🚀 Search
              </Button>
            </Col>
          </Row>
        </Form>



      </Container>
    </div>
  );
};

export default SearchJob;
